// ADR-0156 (#0754) — aviso inmediato al jefe por observación crítica.
//
// Dos lecturas del mismo hecho (la constancia en
// `observation_critical_alerts`), cada una para su audiencia:
//   - `criticalAlertCreateResultSchema` viaja en el 201 de
//     POST /assets/:id/observations, al PROPIETARIO (o al personal que
//     registró): sólo si el aviso se confirmó y a qué tipo de destinatario.
//     Nunca ids ni nombres del personal.
//   - `criticalAlertMarkSchema` viaja al dashboard (lista del proyecto y
//     detalle), sólo a roles de gestión: «Avisada al jefe HH:MM».
// Ninguno de los dos lleva la etiqueta de criticidad: la pinta cada
// cliente desde `CRITICIDAD_LABEL`.
import { z } from "zod";
export const criticalAlertRecipientKindSchema = z.enum(["jefe", "gerentes"]);
/** La marca del dashboard. `sent` = auth-svc confirmó el envío (con su
 *  hora); `failed` = no salió; `unknown` = no sabemos (timeout, o el
 *  proceso cayó a mitad del envío); `no_recipient` = el proyecto no tenía
 *  jefe válido ni gerente activo; `author_is_recipient` = no salió porque
 *  quien la registró era el único a quien avisar (ya lo sabe);
 *  `author_is_jefe` = la registró el jefe actual del proyecto y no se
 *  avisa a nadie (tampoco a los gerentes). */
export const criticalAlertMarkSchema = z.object({
    status: z.enum([
        "sent",
        "failed",
        "unknown",
        "no_recipient",
        "author_is_recipient",
        "author_is_jefe",
    ]),
    at: z.string().datetime().nullable(),
    recipientKind: criticalAlertRecipientKindSchema.nullable(),
});
/** Lo que el 201 le dice a quien registró. `notified` es true sólo si
 *  TODAS las observaciones críticas de la llamada quedaron avisadas; un
 *  timeout cuenta como no confirmado. */
export const criticalAlertCreateResultSchema = z.object({
    notified: z.boolean(),
    recipientKind: criticalAlertRecipientKindSchema.nullable(),
});
//# sourceMappingURL=critical-alerts.js.map